import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography, Button } from 'antd'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import backgroundImage from 'src/assets/images/background-page.png'
import errorOccuredImg from 'src/assets/images/error-occured.png'
import { useSelector } from 'react-redux'
import { getCriticalConfig } from 'src/app/store/masterSetup'
import { colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import RichTextField from '../../components/common/rich-text-field'
import '../access-denied-page/logout.scss'

const SSOUnexpectedErrorOccured: React.FC = () => {
  const { t } = useTranslation()
  const criticalConfig: any = useSelector(getCriticalConfig)

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img className='page-logo' src={bfaLogo} alt='logo' />
      <Card className='page-card' bordered={false}>
        <img src={errorOccuredImg} alt='inactive-user-image' />
        <Typography.Title level={1} style={{ textAlign: 'center', lineHeight: '38px', fontSize: '28px' }}>
          {t('common:sso_unexpected_error_occured')}
        </Typography.Title>

        <Typography.Text type='secondary' style={{ textAlign: 'center', marginBottom: 48, color: colorTextSubtlest }}>
          <RichTextField richText={t('common:sso_issue_contact')} />
        </Typography.Text>

        <Button
          size='large'
          className='btn-back'
          ghost
          onClick={() => window.location.replace(criticalConfig?.clientLogOutLink)}
        >
          {t('LoginPage:logout_inactivity.back_to_commercial_center')}
        </Button>
      </Card>
    </div>
  )
}

export default SSOUnexpectedErrorOccured
